// extracted by mini-css-extract-plugin
export default {"sendBtn":"NewTicket_sendBtn__XJhNu","messageField":"NewTicket_messageField__ewBfa","wrapper":"NewTicket_wrapper__Lvqxq"};